import ProductUpload from "./ProductUpload";

export default ProductUpload;
